<template>
	<div class="text-center">
		<v-container>
			<div v-if="addPaymentContractAfterEnrollment == false" :class="['text-h6', 'pa-4']">
				{{ $t('titles.registration') }}
			</div>
			<div v-else :class="['text-h6', 'pa-4']">
				{{ $t('titles.choosePaymentContract') }}
			</div>
			<v-row>
				<v-col cols="12">
					<InputField
						:disabled="true"
						v-model="candidateFullName"
						:label="$t('fields.candidate')"
					></InputField>
				</v-col>
				<v-col cols="12" class="pb-0 pt-0">
					<v-flex xs12 sm12 md12 lg12 class="pb-0 d-flex justify-start">
						<div :class="['text-body-1', 'pt-5', 'mr-4', 'd-inline-block']">
							{{ $t('labels.paymentContract') }}
						</div>
						<v-radio-group v-model="contractType" row mandatory class="d-inline-block">
							<v-radio :label="$t('fields.candidate')" value="candidate"></v-radio>
							<v-radio :label="$t('fields.partner')" value="partner"></v-radio>
						</v-radio-group>
					</v-flex>
				</v-col>
				<v-col cols="12" class="pt-0" v-if="contractType == 'candidate'">
					<Dropdown2
						v-model="paymentContractOwner"
						:ajax="true"
						:clearable="true"
						:data="'candidate-payment-contract-owners/' + $route.params.id"
						:label="productOwnerLabel"
						:errorBorder="!paymentContractOwnerValidation"
					></Dropdown2>
				</v-col>
				<v-col cols="12" class="pt-0" v-if="contractType == 'partner'">
					<Dropdown2_copy
						v-model="paymentContractOwner"
						:ajax="true"
						:clearable="true"
						:data="'partner-payment-contract-owners/' + $route.params.id"
						:label="$t('fields.partnerWithPaymentContract')"
						:errorBorder="!paymentContractOwnerValidation"
					></Dropdown2_copy>
				</v-col>

				<v-col cols="12" class="pt-0" v-if="contractType == 'candidate' && paymentContractOwner != null">
					<Dropdown2
						v-model="paymentContract"
						:ajax="true"
						:data="'candidate-payment-contracts/' + paymentContractOwner"
						:label="'* ' + $t('fields.paymentContract')"
						:errorBorder="!paymentContractValidation"
						@item-selected="getPaymentContractItemOfCurrentCourse"
					></Dropdown2>
				</v-col>
				<v-col cols="12" class="pt-0" v-if="contractType == 'partner' && paymentContractOwner != null">
					<Dropdown2_copy
						v-model="paymentContract"
						:ajax="true"
						:data="'partner-payment-contracts/' + paymentContractOwner"
						:label="'* ' + $t('fields.paymentContract')"
						:errorBorder="!paymentContractValidation"
						@item-selected="getPaymentContractItemOfCurrentCourse"
					></Dropdown2_copy>
				</v-col>

				<v-col cols="12" v-if="paymentContractExist == true">
					<Dropdown
						v-model="paymentContractItem"
						:ajax="paymentContractExist"
						:data="'payment-contract-items/' + paymentContract + '/' + $route.params.id"
						:errorBorder="!paymentContractItemValidation"
						:label="'* ' + $t('fields.paymentContractItem')"
					></Dropdown>
				</v-col>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row>
			<v-col cols="12">
				<v-btn class="ma-2" color="primary" variant="text" @click="saveClick"> {{ $t('buttons.save') }} </v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import Dropdown from '../../trinkets/Dropdown';
import Dropdown2 from '../../trinkets/Dropdown2';
import Dropdown2_copy from '../../trinkets/Dropdown2_copy';
import InputField from '../../trinkets/InputField';

export default {
	name: 'CandidatePaymentContract',
	components: { Dropdown, Dropdown2, Dropdown2_copy, InputField },
	props: {
		preregistrationId: [String, Number],
		candidateId: [String, Number],
		candidateFullName: [String, Number],
		addPaymentContractAfterEnrollment: {
			type: Boolean,
			default: false,
		},
	},
	emits: [
		'close',
		'reloadParticipants',
		'reloadPlannedCourse',
		'reloadCandidatesRegistrations',
		'reloadCandidatesPreregistrations',
	],
	data() {
		return {
			paymentContract: null,
			paymentContractValidation: true,
			paymentContractItem: null,
			contractType: 'candidate',
			paymentContractItemValidation: true,
			paymentContractExist: false,
			paymentContractOwner: null,
			paymentContractOwnerValidation: true,
		};
	},
	computed: {
		productOwnerLabel() {
			return this.addPaymentContractAfterEnrollment
				? '* ' + this.$t('fields.candidateWithPaymentContract')
				: this.$t('fields.candidateWithPaymentContract');
		},
	},
	watch: {
		paymentContract(newVal) {
			if (newVal !== null) {
				this.paymentContractExist = true;
			} else {
				this.paymentContractExist = false;
			}
		},
		paymentContractOwner(newVal) {
			if (newVal == null) {
				this.paymentContractExist = false;
				this.paymentContract = null;
				this.paymentContractItem = null;
			}
			if (this.contractType == 'candidate') {
				this.getDefaultPaymentContract();
			}
		},
		candidateId() {
			if (this.contractType == 'candidate') {
				this.getDefaultPaymentContract();
			}
		},
		contractType() {
			this.paymentContractOwner = null;
		},
	},
	methods: {
		cancelClick() {
			this.paymentContract = null;
			this.paymentContractItem = null;
			this.$emit('close');
		},
		getDefaultPaymentContract() {
			let vm = this;
			let payload = {
				candidate_id: this.paymentContractOwner,
				planned_course_id: this.$route.params.id,
			};
			this.$APICall('post', 'default-payment-contract', payload, (data, success) => {
				if (success) {
					if (data.default_payment_contract != null || data.default_payment_contract != 'null') {
						vm.paymentContract = data.default_payment_contract;
						vm.paymentContractItem = data.payment_contract_item_id;
					}
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		getPaymentContractItemOfCurrentCourse(item) {
			var vm = this;
			this.paymentContractExist = false;
			let payload = {
				payment_contract_id: item.id,
				planned_course_id: this.$route.params.id,
			};
			this.$APICall(
				'post',
				'default-payment-contract-item',
				payload,
				(data, success) => {
					if (success) {
						vm.paymentContractItem = data.default_payment_contract_item_id;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		saveClick() {
			let success = true;
			if (this.addPaymentContractAfterEnrollment) {
				if (this.paymentContractOwner === null || this.paymentContractOwner === '') {
					success = false;
					this.paymentContractOwnerValidation = false;
				} else {
					this.paymentContractOwnerValidation = true;
				}
			}

			if (this.paymentContract != null && this.paymentContractItem == null) {
				success = false;
				this.paymentContractItemValidation = false;
			} else {
				this.paymentContractItemValidation = true;
			}

			if (this.paymentContractOwner != null && this.paymentContract == null) {
				success = false;
				this.paymentContractValidation = false;
			} else {
				this.paymentContractValidation = true;
			}

			if (success) {
				let vm = this;
				this.$APICall(
					'put',
					'preregistrations/enrollment/' + this.preregistrationId,
					{
						added_payment_contract_after_enrollment: this.addPaymentContractAfterEnrollment,
						enrollment: true,
						payment_contract_item: this.paymentContractItem,
						user_id: this.$myStore.state.user.id,
						planned_course_id: this.$route.params.id,
					},
					(data, success) => {
						if (success) {
							if (data == 409) {
								vm.$alert(vm.$t('alerts.candidateAlreadyEnrolled'));
								this.$emit('close');
								return;
							}

							if (data == 422) {
								vm.$alert(vm.$t('alerts.candidateAlreadyHavePaymentContract'));
								this.$emit('close');
								return;
							}
							vm.$notify(vm.$t('alerts.basicUpdate'));
							vm.$modalBus.$emit('reloadParticipants');
							vm.$modalBus.$emit('reloadPlannedCourse');
							vm.$modalBus.$emit('reloadCandidatesRegistrations');
							vm.$modalBus.$emit('reloadCandidatesPreregistrations');
						} else {
							if (Object.hasOwn(data, 'custom')) {
								vm.$alert(data.message);
								this.$emit('close');
								this.$router.go(-1);
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						}
						this.$emit('close');
					}
				);
			}
		},
	},
};
</script>
